export const toggleTabState = (currentTab = 'general') => ({
  generalTab: currentTab === 'general',
  licenses: currentTab === 'licenses',
  skills: currentTab === 'skills',
  paymentTab: currentTab === 'payment',
  invoicesTab: currentTab === 'invoices',
  jobsTab: currentTab === 'jobs',
  offersTab: currentTab === 'offers',
  editsTab: currentTab === 'edits',
  receiptPDFJobsTab: currentTab === 'receiptPDFJobsTab',
  officeReciptsTab: currentTab === 'officeReciptsTab',
  blockedTab: currentTab === 'blocked',
  npsTab: currentTab === 'nps',
  notesTab: currentTab === 'notes',
  childOfficesTab: currentTab === 'childOffices',
  locationAdminsTab: currentTab === 'location-admins',
  ppJobsTab: currentTab === 'ppJobs',
  permanentJobsTab: currentTab === 'permanent-jobs',
  notificationsTab: currentTab === 'notifications',
  favoritesTab: currentTab === 'favorites',
  workerClassificationTab: currentTab === 'workerClassification',
  highlyRatedTab: currentTab === 'highlyRated',
  reviewTab: currentTab === 'reviewTab',
  mapTab: currentTab === 'mapTab',
  medMalTab: currentTab === 'medMalTab',
  badgesTab: currentTab === 'badges',
  properksGiftCardsTab: currentTab === 'properks-gift-cards',
  properksChallengeTab: currentTab === 'properks-challenge',
  availabilityTab: currentTab === 'availability',
  promotionsTab: currentTab === 'promotions',
  promoCodesTab: currentTab === 'promo-codes',
  campaignsTab: currentTab === 'campaigns',
  gotuFeedbackTab: currentTab === 'gotu-feedback',
  resumeTab: currentTab === 'resume',
  achAuthorizationTab: currentTab === 'achAuthorization',
});
